import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function HourGlass({ color, className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="52"
            height="72"
            fill="none"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M2.30276 70.4459H50.0556M2.30276 2.22754H50.0556M43.2338 70.4459V56.2155C43.2334 54.4064 42.5144 52.6716 41.235 51.3925L26.1792 36.3367M26.1792 36.3367L11.1234 51.3925C9.84397 52.6716 9.12499 54.4064 9.1246 56.2155V70.4459M26.1792 36.3367L11.1234 21.2809C9.84397 20.0019 9.12499 18.267 9.1246 16.4579V2.22754M26.1792 36.3367L41.235 21.2809C42.5144 20.0019 43.2334 18.267 43.2338 16.4579V2.22754"
                stroke={color}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

HourGlass.propTypes = propTypes;
HourGlass.defaultProps = defaultProps;

export default HourGlass;
